import { combineReducers } from 'redux';
import sections from './sections';
import productsDirectory from './productsDirectory';
import newProducts from './newProducts';
import places from './places';

const rootReducer = combineReducers({
  sections,
  productsDirectory,
  newProducts,
  places,
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./web/js/reducers/root.js
 **/